import { Col, Form, Input, Pagination, Row } from "antd";
import { useEffect, useState } from "react";
import { CustomForms } from "./CustomForms";
import FeatureToolbarComponent from "../feature/FeatureToolbarComponent";
import AttributeFormComponent from "../attribute/AttributeFormComponent";

const MapImageLayersInfoResultsComponent = ({ mapUtilities, mapView, table, results, mapLayer, sublayer, setGeometry,
    setGeometryType, currentTabsResult, setCurrenTabsResult }) => {

    const customForms = new CustomForms(results, mapLayer, sublayer, currentTabsResult, setCurrenTabsResult, setGeometry, setGeometryType);

    return (
        <>
            {customForms.hasCustomForm() && customForms.renderForm(mapView, table, mapLayer, sublayer)}
            {!customForms.hasCustomForm() &&
                <MapImageLayersDefaultInfoResultsComponent mapUtilities={mapUtilities} mapView={mapView} table={table} results={results}
                    mapLayer={mapLayer} sublayer={sublayer} setGeometry={setGeometry}
                    setGeometryType={setGeometryType}
                    currentTabsResult={currentTabsResult}
                    setCurrenTabsResult={setCurrenTabsResult} />}
        </>
    );
}

export default MapImageLayersInfoResultsComponent;


const MapImageLayersDefaultInfoResultsComponent = ({ mapUtilities, mapView, table, results, mapLayer, sublayer, setGeometry,
    setGeometryType, currentTabsResult, setCurrenTabsResult }) => {

    const [fields, setFields] = useState();
    const [layerLoaded, setLayerLoaded] = useState(false);


    const [result, setResult] = useState(results[0]);
    const [current, setCurrent] = useState(1);

    const hiddenAttributes = ["OBJECTID", "SHAPE"];

    useEffect(() => {       
        let sublayer = getSublayer();
        if (!sublayer.loaded) {
            sublayer.load().then((result) => {
                setFields(getSublayer().fields);
                setLayerLoaded(true);
            }, (error) => {
                console.error(error);
            });
        }
        else {
            setFields(getSublayer().fields);
            setLayerLoaded(true)
        }

    }, [mapLayer, sublayer]);

    const getMapLayer = () => {
        let out = null;
        for (let layerView of mapView.layerViews) {
            if (layerView.layer.title == mapLayer.name) {
                out = layerView.layer;
            }
        }
        //console.log("getMapLayer", out)
        return out;
    }

    const getSublayer = () => {
        let out = null;
        let allSublayers = getMapLayer().allSublayers;
        for (let sl of allSublayers) {
            if (sl.id == sublayer.id) {
                out = sl;
            }
        }
        //console.log("getSublayer", out)
        return out;
    }

    const getField = (name) => {
        let out = null;
        for (let field of fields) {
            if (field.name == name) {
                out = field;
            }
        }
        //console.log("getField", out)
        return out;
    }

    const getFieldAlias = (name) => {
        let field = getField(name);

        if (field != null && field.alias != null) {
            return field.alias;
        }
        else {
            return name;
        }
    }


    const onChangePagination = (page) => {
        setCurrent(page);
        setResult(results[page - 1]);
        setGeometry(results[page - 1].feature.geometry)
        setGeometryType(results[page - 1].feature.geometry.type)
        let copy = Object.assign({}, currentTabsResult);
        copy[mapLayer.name + ": " + sublayer.title] = results[page - 1];
        setCurrenTabsResult(copy);

    };

   
    return (
        <>
            {results.length > 1 && <Row>
                <Col span={24}>
                    <Pagination style={{ float: "right" }} simple pageSize={1} current={current} onChange={onChangePagination}
                        total={results.length} />
                </Col>
            </Row>}

            <Row justify="end" style={{ paddingBottom: "10px", paddingTop: "5px" }}>
                <FeatureToolbarComponent mapView={mapView} table={table} mapLayer={mapLayer} sublayer={sublayer} feature={result.feature}></FeatureToolbarComponent>
            </Row>

            <Form
                layout="vertical"
            >
                {fields && layerLoaded &&
                    Object.keys(result.feature.attributes).map(function (key) {
                        if (!hiddenAttributes.includes(key)) {
                            return <Form.Item key={"attribute_" + key} label={getFieldAlias(key) /*getFieldAlias(key)*/}>
                                {/*<Input value={result.feature.attributes[key]} readOnly={true}></Input>*/}
                                <AttributeFormComponent feature={result.feature} field={getField(key)}></AttributeFormComponent>
                            </Form.Item>
                        }
                    })}

            </Form>


            {results.length > 1 && <Row>
                <Col span={24}>
                    <Pagination style={{ float: "right" }} simple pageSize={1} current={current} onChange={onChangePagination}
                        total={results.length} />
                </Col>
            </Row>}
        </>
    );
}